import analyse from "./class/analyse";
import assess from "./class/assess";

const analyseApi = analyse;
const assessApi = assess;
export { analyseApi, assessApi };
